import type { Metadata } from "next";

/**
 * Lambang MERK PLATFORM (Kelolify) — berkas statis di repo, dibuat ulang
 * lewat `node scripts/gen-platform-icons.mjs`.
 *
 * ── Kenapa set sendiri, bukan `/icons/icon-*.png` ──────────────────────────
 * `/icons/icon-*.png` adalah ikon STOREFRONT: ubin oranye ber-monogram toko
 * kanonik. Seluruh halaman `/platform/*` dulu menunjuk ke sana dengan komentar
 * "ikon netral" — maksudnya melepas ikon PWA milik TENANT, dan itu memang
 * tercapai; yang luput, penggantinya tetap ikon toko, jadi tab kelolify.com
 * memakai lambang toko, bukan lambang platform.
 *
 * Warnanya #27228F — `--theme-primary` yang dipasang globals.css untuk
 * `body:has([data-platform-page])`, sama dengan `themeColor` layout `(public)`
 * dan dengan lambang di `public/platform-og.png`.
 *
 * ⚠️ Berbeda dari lambang di header situs jualan (`PLATFORM_LOGO_URL`), berkas
 * di sini TIDAK bisa diganti dari panel: favicon wajib persegi, ringan, dan
 * terbaca pada 16 px, sedangkan unggahan pemilik platform bebas rasio. Ikon
 * unggahan tetap yang tampil di header; berkas ini yang tampil di tab.
 */

/** Ukuran favicon — full bleed, monogram dibesarkan agar terbaca di tab. */
export const PLATFORM_ICON_32 = "/icons/platform-icon-32.png";
/** Ubin rounded untuk tab beresolusi tinggi & pintasan layar utama. */
export const PLATFORM_ICON_192 = "/icons/platform-icon-192.png";
/** Ubin rounded 512 — juga dipakai sebagai `logo` di JSON-LD Organization. */
export const PLATFORM_ICON_512 = "/icons/platform-icon-512.png";
/** Kotak penuh solid tanpa alpha; iOS me-rounding sendiri. */
export const PLATFORM_APPLE_TOUCH_ICON = "/icons/platform-apple-touch-icon.png";

/**
 * Blok `icons` yang WAJIB dipakai SETIAP halaman/layout di bawah `/platform`.
 *
 * Satu konstanta, bukan disalin per halaman: penggabungan metadata Next
 * bersifat DANGKAL, jadi tiap halaman platform menulis blok `icons` utuh
 * sendiri — lima salinan yang dulu bisa (dan sempat) menyimpang satu sama lain.
 * Ditegakkan `__tests__/platformIcons.test.ts`.
 */
export const PLATFORM_METADATA_ICONS: Metadata["icons"] = {
  icon: [
    { url: PLATFORM_ICON_32, sizes: "32x32", type: "image/png" },
    { url: PLATFORM_ICON_192, sizes: "192x192", type: "image/png" },
    { url: PLATFORM_ICON_512, sizes: "512x512", type: "image/png" },
  ],
  apple: [{ url: PLATFORM_APPLE_TOUCH_ICON, sizes: "180x180" }],
};

/** Semua berkas lambang platform — dipakai tes penahanan. */
export const PLATFORM_ICON_FILES = [
  PLATFORM_ICON_32,
  PLATFORM_ICON_192,
  PLATFORM_ICON_512,
  PLATFORM_APPLE_TOUCH_ICON,
] as const;
